module.exports = __webpack_public_path__ + "static/media/metro.1bcf794a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/metro.svg
// module id = 172
// module chunks = 0